import { BaseItemTypes } from "@/components/dnd/ItemTypes";
import { AnalyticsFormulaTokenDescriptor, AnalyticsFormulaOperationType, ParameterLinkSummablePartType } from "@/models/etc/types";
import { arrayEquals, findRecursive } from "@/models/helpers/recursive";
import { AnalyticsFormulaToken, AnalyticsFormulaOperation, AnalyticsFormulaOperand, AnalyticsFormulaLinkToFormula, 
  AnalyticsFormulaLinkToParameter, ParameterLinkSummablePart, AnalyticsFormulaGlobalLinkToTableFormula } from "@/models/interfaces/entity-settings/parameters/parameters";
import { rootStore } from "@/store";
import { useEventListener } from "@vueuse/core";
import { buildAbsoluteClientUrl } from "@/utils/urlHelpers";

// formula tokenizer
export const TokenTypes = {
  NUMBER: 'NUMBER',
  NOTNUMBER: 'NOTNUMBER',
  ADDITION: '+',
  SUBTRACTION: '-',
  MULTIPLICATION: '*',
  TOTALSUM: '?',
  DIVISION: '/',
  PARENTHESIS_LEFT: '(',
  PARENTHESIS_RIGHT: ')',
};

export enum detailTokenType {
  Unknown = 0,
  ColumnParameter = 1,
  CommonParameter = 2,
  Formula = 3,
  GlobalFormula = 4,
}

// [/^([^0-9()*-/+?]|\s)+\d*/, TokenTypes.NOTNUMBER],

const TokenSpec = [
  [/^\+/, TokenTypes.ADDITION],
  [/^-/, TokenTypes.SUBTRACTION],
  [/^\*/, TokenTypes.MULTIPLICATION],
  [/^\?/, TokenTypes.TOTALSUM],
  [/^\//, TokenTypes.DIVISION],
  [/^\(/, TokenTypes.PARENTHESIS_LEFT],
  [/^\)/, TokenTypes.PARENTHESIS_RIGHT],
  // starts with a non-digit, not an operation and not a space,
  // optionally can end with set of digits
  [/^[^0-9()*-/+?]+([^()*-/+?]|\s|\.)*/, TokenTypes.NOTNUMBER],
  [/^\d+\.\d+|\d+/, TokenTypes.NUMBER],
  [/^\s+/, null],
];

export function makeHtmlTokenTemplate(detailData: any, apiToken: AnalyticsFormulaToken | undefined, 
  element_id: string, that: any, toggle_sum: (ref: string, s_ref: string, part_id: number) => any | undefined,
  toggle_replace: (ref: string, s_ref: string, part_id: number) => any | undefined, 
  toggle_input: (text: string, index_into: number) => any | undefined, toggle_delete: (index_into: number) => any | undefined,
  index_into: number, templateName: string, isLast: boolean, readOnly: boolean = false) {
  let colorValue = ''
  if (!apiToken) {
    colorValue = 'red'
    const token_html = `<span id="${element_id}" style="color: ${colorValue}; cursor: pointer;">${detailData.textValue}`+
    (!isLast ?
      `<span contenteditable id="input_${element_id}" style="display: inline-block; 
  min-width: 3px; max-width: fit-content; background: transparent; 
  color: black; border-bottom: 1px solid lightgrey; cursor: text;"/>` : '')+
      '</span>'

    // wait a little in order to get these new DOM-elements with id = element_id to be rendered correctly
    // because it seems like $nextTick doesn't work inside another $nextTick
    setTimeout(() => {
      that.$nextTick(() => {
        if (!readOnly) {
          useEventListener(document.getElementById(element_id), 'click', (e) => {
            toggle_replace(element_id, "", 0)
            e.stopPropagation()
          })

          if (!isLast) {
            useEventListener(document.getElementById('input_'+element_id), 'keydown', (e) => {
              if (e.key === 'Enter') {
                const el = document.getElementById('input_'+element_id);
                if (el && el.textContent) {
                  toggle_input(el.textContent, index_into)
                }
                e.stopPropagation()
              } else if (e.key === 'Backspace') {
                toggle_delete(index_into)
                e.stopPropagation()
              } else if (e.key === 'Delete') {
                toggle_delete(index_into)
                e.stopPropagation()
              }
            })
            useEventListener(document.getElementById('input_'+element_id), 'blur', (e) => {
              const el = document.getElementById('input_'+element_id);
              el && (el.textContent = '')
            })
            useEventListener(document.getElementById('input_'+element_id), 'click', (e) => {
              e.preventDefault()
              e.stopPropagation()
            })
          }
        }
      })
    }, 100);
    
    console.log('returnin '+token_html)
    return token_html
  } else if (apiToken.Descriptor !== AnalyticsFormulaTokenDescriptor.LinkToParameter && 
    apiToken.Descriptor !== AnalyticsFormulaTokenDescriptor.GlobalLinkToTableFormula) {
    let isBold = false
    switch (apiToken.Descriptor) {
      case AnalyticsFormulaTokenDescriptor.Operand:
        colorValue = '#3BB2E2'; // blue
        break;
      case AnalyticsFormulaTokenDescriptor.LinkToFormula:
        colorValue = '#499259'; // green
        break;
      case AnalyticsFormulaTokenDescriptor.Operation:
      case AnalyticsFormulaTokenDescriptor.LeftBracket:
      case AnalyticsFormulaTokenDescriptor.RightBracket:
        colorValue = 'black';
        isBold = true;
        break;
      case AnalyticsFormulaTokenDescriptor.TotalResultsCount:
        colorValue = '#499259'; // green
          break;
      default:
        colorValue = 'black';
        break;
    }
    console.log('returning '+detailData.textValue)

    if (apiToken.Descriptor === AnalyticsFormulaTokenDescriptor.LinkToFormula) {
      // wait a little in order to get these new DOM-elements with id = element_id to be rendered correctly
      // because it seems like $nextTick doesn't work inside another $nextTick
      setTimeout(() => {
        that.$nextTick(() => {
          if (!readOnly) {
            useEventListener(document.getElementById(element_id), 'click', (e) => {
              toggle_replace(element_id, "", 0)
              e.stopPropagation()
            })

            if (!isLast) {
              useEventListener(document.getElementById('input_'+element_id), 'keydown', (e) => {
                if (e.key === 'Enter') {
                  const el = document.getElementById('input_'+element_id);
                  if (el && el.textContent) {
                    toggle_input(el.textContent, index_into)
                  }
                  e.stopPropagation()
                } else if (e.key === 'Backspace') {
                  toggle_delete(index_into)
                  e.stopPropagation()
                } else if (e.key === 'Delete') {
                  toggle_delete(index_into)
                  e.stopPropagation()
                }
              })
              useEventListener(document.getElementById('input_'+element_id), 'blur', (e) => {
                const el = document.getElementById('input_'+element_id);
                el && (el.textContent = '')
              })
              useEventListener(document.getElementById('input_'+element_id), 'click', (e) => {
                e.preventDefault()
                e.stopPropagation()
              })
            }
          }
        })
      }, 200);
      
      return `<span id="${element_id}" ${isBold ? 'class="text-bold"' : ''} style="color: ${colorValue}; cursor: pointer;">${
      detailData.textValue}`+(!isLast ? `<span contenteditable id="input_${element_id
        }" style="display: inline-block; min-width: 3px; max-width: fit-content; background: transparent; color: black; border-bottom: 1px solid lightgrey; cursor: text;"/>` : '')+
      `</span>`
    } else {
      
      if (!isLast) {
        // wait a little in order to get these new DOM-elements with id = element_id to be rendered correctly
        // because it seems like $nextTick doesn't work inside another $nextTick
        setTimeout(() => {
          that.$nextTick(() => {
            if (!readOnly) {
              useEventListener(document.getElementById('input_'+element_id), 'keydown', (e) => {
                if (e.key === 'Enter') {
                  const el = document.getElementById('input_'+element_id);
                  if (el && el.textContent) {
                    toggle_input(el.textContent, index_into)
                  }
                  e.stopPropagation()
                } else if (e.key === 'Backspace') {
                  const el = document.getElementById('input_'+element_id);
                  if (el && !el.textContent) {
                    toggle_delete(index_into)
                    e.stopPropagation()
                  }
                } else if (e.key === 'Delete') {
                  const el = document.getElementById('input_'+element_id);
                  if (el && !el.textContent) {
                    toggle_delete(index_into)
                    e.stopPropagation()
                  }
                }
              })
              useEventListener(document.getElementById('input_'+element_id), 'blur', (e) => {
                const el = document.getElementById('input_'+element_id);
                el && (el.textContent = '')
              })
              useEventListener(document.getElementById('input_'+element_id), 'click', (e) => {
                e.preventDefault()
                e.stopPropagation()
              })
            }
          })
        }, 200);
      }

      return `<span id="${element_id}" ${isBold ? 'class="text-bold"' : ''} style="color: ${colorValue}; cursor: pointer;">${
      detailData.textValue}`+(!isLast ? `<span contenteditable id="input_${element_id
        }" style="display: inline-block; min-width: 3px; max-width: fit-content; background: transparent; color: black; border-bottom: 1px solid lightgrey; cursor: text;"/>` : '')+
      `</span>`
    }
  } else if (apiToken.Descriptor === AnalyticsFormulaTokenDescriptor.LinkToParameter) {
    colorValue = 'green';
    // several spans each with its own summable listener and id
    // Maybe use .filter((el: ParameterLinkSummablePart) => el.Id) in order not to white down Category
    console.log('returning category')
    return detailData.originElement.map((el: any) => {
      const elId = (templateName ? el[templateName].Id : el.Id)
      const elName = (templateName ? el[templateName].Name : el.Name)
      const token_summablelink = (apiToken as AnalyticsFormulaLinkToParameter).ParameterLink.LinkParts.find((part: ParameterLinkSummablePart) => part.Id === elId)
      let token_html = 
        (el.IsList && elId ? '<span class="text-bold" id="'+element_id+'sum'+elId+
        '" style="color: '+(token_summablelink ? (token_summablelink.Type ? 'black' : 'grey') : 'red')+'; cursor: pointer;">Σ</span>' : '')+
        '<span id="'+element_id + (elId ? '_'+elId : 'cat') + `" style="color: ${colorValue}; cursor: pointer;">${elName}</span>`

        if (token_summablelink) {
          // wait a little in order to get these new DOM-elements with id = element_id+'sum'+el.Id to be rendered correctly
          // because it seems like $nextTick doesn't work inside another $nextTick
          setTimeout(() => {
            that.$nextTick(() => {
              if (!readOnly) {
                useEventListener(document.getElementById(element_id+'sum'+elId), 'click', (e) => {
                  toggle_sum(element_id, element_id+'sum'+elId, token_summablelink.Id)
                })
                if (elId) {
                  useEventListener(document.getElementById(element_id+'_'+elId), 'click', (e) => {
                    toggle_replace(element_id, element_id+'_'+elId, token_summablelink.Id)
                    e.stopPropagation()
                  })
                }

                if (!isLast) {
                  useEventListener(document.getElementById('input_'+element_id), 'keydown', (e) => {
                    if (e.key === 'Enter') {
                      const el = document.getElementById('input_'+element_id);
                      if (el && el.textContent) {
                        toggle_input(el.textContent, index_into)
                      }
                      e.stopPropagation()
                    } else if (e.key === 'Backspace') {
                      toggle_delete(index_into)
                      e.stopPropagation()
                    } else if (e.key === 'Delete') {
                      toggle_delete(index_into)
                      e.stopPropagation()
                    }
                  })
                  useEventListener(document.getElementById('input_'+element_id), 'blur', (e) => {
                    const el = document.getElementById('input_'+element_id);
                    el && (el.textContent = '')
                  })
                  useEventListener(document.getElementById('input_'+element_id), 'click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                  })
                }
              }
            })
          }, 100);
        }
      token_html = !isLast ? '<span>'+token_html+`<span contenteditable id="input_${element_id}" style="display: inline-block; 
        min-width: 3px; max-width: fit-content; background: transparent; 
        color: black; border-bottom: 1px solid lightgrey; cursor: text;"/>`+'</span>' : token_html
      return token_html
    }).join('.')
  } else { // apiToken.Descriptor === AnalyticsFormulaTokenDescriptor.GlobalLinkToTableFormula
    colorValue = 'green';
    // several spans each with its own summable listener and id
    // Maybe use .filter((el: ParameterLinkSummablePart) => el.Id) in order not to white down Category
    console.log('returning global formula')
    console.log(detailData)

    let total_token = '';

      total_token = detailData.originElement.map((el: any) => {
        const elId = (templateName ? el[templateName].Id : el.Id)
        const elName = (templateName ? el[templateName].Name : el.Name)
        
        let token_html = '<span id="'+element_id + (elId ? '_'+elId : 'gf') + `" style="color: ${colorValue}; cursor: pointer;">${elName}</span>`

        // wait a little in order to get these new DOM-elements with id = element_id+'sum'+el.Id to be rendered correctly
        // because it seems like $nextTick doesn't work inside another $nextTick
        setTimeout(() => {
          that.$nextTick(() => {
            if (!readOnly) {
                if (elId) {
                  useEventListener(document.getElementById(element_id+'_'+elId), 'click', (e) => {
                    toggle_replace(element_id, element_id+'_'+elId, 0)
                    e.stopPropagation()
                  })
                } else {
                  console.log('skip replace')
                }

                if (!isLast) {
                  useEventListener(document.getElementById('input_'+element_id), 'keydown', (e) => {
                    if (e.key === 'Enter') {
                      const el = document.getElementById('input_'+element_id);
                      if (el && el.textContent) {
                        toggle_input(el.textContent, index_into)
                      }
                      e.stopPropagation()
                    } else if (e.key === 'Backspace') {
                      toggle_delete(index_into)
                      e.stopPropagation()
                    } else if (e.key === 'Delete') {
                      toggle_delete(index_into)
                      e.stopPropagation()
                    }
                  })
                  useEventListener(document.getElementById('input_'+element_id), 'blur', (e) => {
                    const el = document.getElementById('input_'+element_id);
                    el && (el.textContent = '')
                  })
                  useEventListener(document.getElementById('input_'+element_id), 'click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                  })
                }
              }
          })
        }, 100);

        token_html = !isLast ? '<span>'+token_html+`<span contenteditable id="input_${element_id}" style="display: inline-block; 
          min-width: 3px; max-width: fit-content; background: transparent; 
          color: black; border-bottom: 1px solid lightgrey; cursor: text;"/>`+'</span>' : token_html
        return token_html
      }).join('.');

      const rootstore = rootStore()
      const last_el = detailData.originElement[detailData.originElement.length-1]
      if (readOnly && last_el && last_el.Identity) {
        const elType = last_el.Identity?.Source !== undefined && last_el.Identity?.Source !== null ? BaseItemTypes.PROJECTION : BaseItemTypes.SELECTION;
        const newurl = buildAbsoluteClientUrl('analytics?type='+elType+'&src=' + (last_el.Identity?.Source === undefined ? '' : last_el.Identity?.Source) +
        '&dest='+rootstore.generalMode+'&id='+last_el.Identity?.ElementId)
        total_token = '<a target="_blank" style="text-decoration: none;" href="'+newurl+'">'+total_token+'</a>'
      }

    console.log(total_token)
    return total_token
  }
}

export function makeApiFormulaToken(token: any, detail: detailTokenType = detailTokenType.Unknown, 
  detailData: any = undefined, templateName: string = '') {
  if (!token || (token.type === TokenTypes.NOTNUMBER && detail === detailTokenType.Unknown) ||
  ((detail === detailTokenType.ColumnParameter || detail === detailTokenType.CommonParameter || detail === detailTokenType.GlobalFormula) && !detailData)) {
    return undefined
  }

  let descriptor: AnalyticsFormulaTokenDescriptor = AnalyticsFormulaTokenDescriptor.Operand;
  switch (token.type) {
    case TokenTypes.ADDITION:
    case TokenTypes.SUBTRACTION:
    case TokenTypes.MULTIPLICATION:
    case TokenTypes.DIVISION:
      descriptor = AnalyticsFormulaTokenDescriptor.Operation;
      break;
    case TokenTypes.PARENTHESIS_LEFT:
      descriptor = AnalyticsFormulaTokenDescriptor.LeftBracket;
      break;
    case TokenTypes.PARENTHESIS_RIGHT:
      descriptor = AnalyticsFormulaTokenDescriptor.RightBracket;
      break;
    case TokenTypes.TOTALSUM:
      descriptor = AnalyticsFormulaTokenDescriptor.TotalResultsCount;
      break;
    case TokenTypes.NOTNUMBER:
      descriptor = [ detailTokenType.ColumnParameter, detailTokenType.CommonParameter ].includes(detail) ?
         AnalyticsFormulaTokenDescriptor.LinkToParameter : 
         (detail === detailTokenType.GlobalFormula ? AnalyticsFormulaTokenDescriptor.GlobalLinkToTableFormula : AnalyticsFormulaTokenDescriptor.LinkToFormula)
      break;
    case TokenTypes.NUMBER:
    default:
      descriptor = AnalyticsFormulaTokenDescriptor.Operand;
      break;
  }

  const apiToken: AnalyticsFormulaToken = {
    Descriptor: descriptor
  }

  if (apiToken.Descriptor === AnalyticsFormulaTokenDescriptor.Operation) {
    let operation_type: AnalyticsFormulaOperationType = AnalyticsFormulaOperationType.Plus;
    switch (token.type) {
      case TokenTypes.SUBTRACTION:
        operation_type = AnalyticsFormulaOperationType.Minus;
        break;
      case TokenTypes.MULTIPLICATION:
        operation_type = AnalyticsFormulaOperationType.Multiply;
        break;
      case TokenTypes.DIVISION:
        operation_type = AnalyticsFormulaOperationType.Divide;
        break;
      case TokenTypes.ADDITION:
      default:
        operation_type = AnalyticsFormulaOperationType.Plus;
        break;
    }
    (apiToken as AnalyticsFormulaOperation).OperationType = operation_type
  } else if (apiToken.Descriptor === AnalyticsFormulaTokenDescriptor.Operand) {
    (apiToken as AnalyticsFormulaOperand).Value = +token.value
  }

  if (detail === detailTokenType.ColumnParameter || detail === detailTokenType.CommonParameter) {
    (apiToken as AnalyticsFormulaLinkToParameter).ParameterLink = {
      LinkParts: detailData.map((el: any) => {
        const res: ParameterLinkSummablePart = {
          Id: templateName ? el[templateName].Id : el.Id,
          Type: el.IsList ? ParameterLinkSummablePartType.ElementsSum : ParameterLinkSummablePartType.FirstElement
        }
        return res
      }).filter((el: ParameterLinkSummablePart) => el.Id)
    }
  }
  
  if (detail === detailTokenType.Formula) {
    (apiToken as AnalyticsFormulaLinkToFormula).FormulaId = detailData.Id
  }

  if (detail === detailTokenType.GlobalFormula && detailData && detailData.length) {
    console.log(detailData);
    (apiToken as AnalyticsFormulaGlobalLinkToTableFormula).FormulaId = templateName ? detailData[detailData.length-1][templateName].PureId : detailData[detailData.length-1].Id;
    (apiToken as AnalyticsFormulaGlobalLinkToTableFormula).FormulaName = templateName ? detailData[detailData.length-1][templateName].Name : detailData[detailData.length-1].Name;
    (apiToken as AnalyticsFormulaGlobalLinkToTableFormula).OwnerId = detailData[detailData.length-1].Identity?.ElementId;
    (apiToken as AnalyticsFormulaGlobalLinkToTableFormula).OwnerKind = detailData[detailData.length-1].Identity?.Kind;
    if (detailData[detailData.length-1].Identity && detailData[detailData.length-1].Identity.Source) {
      (apiToken as AnalyticsFormulaGlobalLinkToTableFormula).OwnerSource = detailData[detailData.length-1].Identity.Source;
    }
  }

  return apiToken
}

export function findParametersByChain(chain: number[], options: any[], nestedName: string, templateName: string = '') {
  if (!chain || !options) { return [] }

  const params = findRecursive(function a(element: any, el_to_find: any): any | undefined {
    if (!element) return undefined

    if ((!templateName || element[templateName]) && arrayEquals([ ...el_to_find.chain, templateName ? element[templateName].Id : element.Id ], el_to_find.el_to_find)) {
      return [element];
    }
    if (element[nestedName]) {
      const childparam = findRecursive(a, {
        chain: (!templateName || element[templateName]) ? [ ...el_to_find.chain, templateName ? element[templateName].Id : element.Id ] : el_to_find.chain,
        el_to_find: el_to_find.el_to_find
      }, element[nestedName])
    
      return childparam ? [ element, ...childparam ] : undefined
    }
    return undefined
  }, { chain: [], el_to_find: chain }, options)

  return params || []
}

export class Tokenizer {
  input: string = '';
  cursor: number = 0;

  constructor(input: string) {
    this.input = input;
    this.cursor = 0;
  }

  hasMoreTokens() {
    return this.cursor < this.input.length;
  }

  match(regex: any, inputSlice: string) {
    const matched = regex.exec(inputSlice);
    if (matched === null) {
      return null;
    }

    this.cursor += matched[0].length;
    console.log(matched)
    return matched[0];
  }

  // acceptNumber = true - this token can be a number
  getNextToken(acceptNumber: boolean = true): any {
    if (!this.hasMoreTokens()) {
      return null;
    }

    const inputSlice = this.input.slice(this.cursor);

    for (const [regex, type] of TokenSpec) {
      if (acceptNumber || type !== TokenTypes.NUMBER) {
        const tokenValue = this.match(regex, inputSlice);

        // No rule was matched!
        if (tokenValue === null) {
          continue;
        }

        // Skip whitespace!
        if (type === null) {
          return this.getNextToken(acceptNumber);
        }

        console.log('reckognized token: '+tokenValue)
        console.log('acceptNumber: '+acceptNumber)
        return {
          type,
          value: tokenValue,
        };
      }
    }

    // throw new SyntaxError(`Unexpected token: "${inputSlice[0]}"`);
  }
}